import Button from '@rio-cloud/rio-uikit/Button';
import { FormattedMessage } from 'react-intl';

type ServiceOptionSidebarFooterProps = {
    onClose: () => void;
};

export const ServiceOptionSidebarFooter = (props: ServiceOptionSidebarFooterProps) => {
    return (
        <div className="display-flex gap-10 flex-row-reverse">
            <Button className={Button.DEFAULT} onClick={props.onClose}>
                <FormattedMessage id="outboundPortal.close" />
            </Button>
        </div>
    );
};
